module.exports = __webpack_public_path__ + "img/sld_scb_26_t1_b1_green.bb83da13.svg";